<template>
  <v-app dark>
    <router-view></router-view>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="3000"
      app
      top
      centered
      :color="snackbar.color"
      style="margin-top:60px;"
    >
      {{ snackbar.text }}
      <template #action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="$store.commit('global/HIDE_SNACKBAR')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <div>
      <v-tour
        name="myTour"
        :steps="steps"
        :options="myOptions"
        :callbacks="myCallbacks"
      ></v-tour>
    </div>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import help from "../src/common/help";
export default {
  data() {
    return {
      steps: [],
      myOptions: {
        highlight: false, // 是否高亮显示激活的的target项
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "关闭",
          buttonPrevious: "上一步",
          buttonNext: "下一步",
          buttonStop: "完成",
        },
      },
      myCallbacks: {
        onPreviousStep: this.myCustomPreviousStepCallback,
        onNextStep: this.myCustomNextStepCallback,
        onStop: this.stop,
      },
    };
  },
  computed: {
    ...mapGetters(["getSnackbar",'isMobile']),
    snackbar: {
      get() {
        return this.$store.state.global.snackbar;
      },
      set(val) {
        this.$store.commit("UPDATE_SNACKBAR", val);
      },
    },
  },
  methods: {
    /** 上一步点击回调 */
    myCustomPreviousStepCallback(e) {},

    /** 下一步点击回调 */
    myCustomNextStepCallback(e) {
      // console.log(this.steps,e)
    },

    async handleProjectChange(status) {
      this.$store.dispatch("courseAndProject/reverseShowProjectEdit", status);
    },
    async enableBoot(that) {
      // dashboard  首页
      // design  课程编辑
      // course  课程管理
      // devicelib  模型资源库
      // resourceLibrary  媒体资源库
      // simclass  仿真实训
      // simclass  仿真实训
      // applymod  模型申请
      var reg1 = new RegExp("/", "g"); // 加'g'，删除字符串里所有的"a"
      var routerName = window.location.pathname.replace(reg1, "");
      that.steps = await help[routerName]();
      setTimeout(() => {
        that.$tours["myTour"].start();
      }, 200);
    },
    stop(e) {},
  },
  destroyed() {
    this.$EventBus.$off("enableBoots");
    this.$EventBus.$off("showDialogs");
    this.$EventBus.$off("hiddenDialogs");
  },
  mounted() {
    this.steps = help.home;
    let that = this;
    this.$EventBus.$on("enableBoots", function (data) {
      that.enableBoot(that);
    });

    this.$EventBus.$on("showDialogs", function (data) {
      if (data) {
        that.$store.dispatch("courseAndProject/reverseShowProjectEdit", "add");
      } else {
        that.$store.dispatch(
          "courseAndProject/reverseShowProjectEdit",
          "close"
        );
      }
    });
    this.$EventBus.$on("hiddenDialogs", function (data) {
      that.$store.dispatch("courseAndProject/reverseShowProjectEdit", "close");
    });
  
    let _this = this;
    window.addEventListener('resize', function() {
    var width = window.innerWidth || document.documentElement.clientWidth;
    // var height = window.innerHeight || document.documentElement.clientHeight;
 
    if (width <= 600) {
      _this.$store.dispatch("isMobile/setIsMobile", true);
      // 这是移动设备
    }else{
      _this.$store.dispatch("isMobile/setIsMobile", false);
    }
});
  },
  created(){
    if (window.innerWidth <= 600) {
        this.$store.dispatch("isMobile/setIsMobile", true);
      // 这是移动设备
    }else{
      this.$store.dispatch("isMobile/setIsMobile", false);
    }
  }

};
</script>
